export default __webpack_public_path__ + "static/media/Individual.3b3e30d3.svg";